<template>
  <div>
    <div class="save-state-row">
      <span class="save-state-label">Auto save</span>
      <span class="save-state" :class="saveStateClass">
        {{ saveStateText }}
      </span>
    </div>

    <div class="table-responsive config-list-table">
      <table class="table">
        <tr>
          <td class="align-middle">เวลาสำหรับการเล่นแต่ละครั้ง</td>
          <td width="100" align="right">
            <input
              type="number"
              class="form-control"
              v-model.number="localForm.play_sec"
              min="0"
              max="100"
              @input="onFieldInput"
              @blur="onFieldBlur"
            />
          </td>
          <td class="align-middle" width="80" align="left">วินาที</td>
        </tr>
        <tr>
          <td class="align-middle">คะแนนสำหรับ SKU1</td>
          <td width="100" align="right">
            <input
              type="number"
              class="form-control"
              v-model.number="localForm.point_0"
              min="0"
              max="100"
              @input="onFieldInput"
              @blur="onFieldBlur"
            />
          </td>
          <td class="align-middle" width="80" align="left">คะแนน</td>
        </tr>
        <tr>
          <td class="align-middle">คะแนนสำหรับ SKU2</td>
          <td width="100" align="right">
            <input
              type="number"
              class="form-control"
              v-model.number="localForm.point_1"
              min="0"
              max="100"
              @input="onFieldInput"
              @blur="onFieldBlur"
            />
          </td>
          <td class="align-middle" width="80" align="left">คะแนน</td>
        </tr>
        <tr>
          <td class="align-middle">คะแนนสำหรับ SKU3</td>
          <td width="100" align="right">
            <input
              type="number"
              class="form-control"
              v-model.number="localForm.point_2"
              min="0"
              max="100"
              @input="onFieldInput"
              @blur="onFieldBlur"
            />
          </td>
          <td class="align-middle" width="80" align="left">คะแนน</td>
        </tr>
        <tr>
          <td class="align-middle">คะแนนสำหรับ VIP</td>
          <td width="100" align="right">
            <input
              type="number"
              class="form-control"
              v-model.number="localForm.point_vip"
              min="0"
              max="100"
              @input="onFieldInput"
              @blur="onFieldBlur"
            />
          </td>
          <td class="align-middle" width="80" align="left">คะแนน</td>
        </tr>
        <tr>
          <td class="align-middle">คะแนนสำหรับระเบิด</td>
          <td width="100" align="right">
            <input
              type="number"
              class="form-control"
              v-model.number="localForm.point_bomb"
              min="-100"
              max="0"
              @input="onFieldInput"
              @blur="onFieldBlur"
            />
          </td>
          <td class="align-middle" width="80" align="left">คะแนน</td>
        </tr>
      </table>
    </div>

    <hr />

    <div
      class="d-flex justify-content-between align-items-center mb-20 theme-row"
    >
      <h4 class="mb-0">Theme</h4>

      <select
        class="form-control w-250"
        v-model.number="localForm.theme_id"
        @change="onFieldBlur"
      >
        <option v-for="theme in themes" :key="theme.id" :value="theme.id">
          {{ ` ${theme.id} - ${theme.name}` }}
        </option>
      </select>
    </div>

    <hr />

    <div class="d-flex justify-content-between align-items-start no-play-row">
      <div>
        <h5 class="mb-5">No. play per day</h5>
        <p class="text-help">
          สำหรับ Ufu ส่วนนี้แสดงค่าเดิมและไม่อนุญาตให้แก้ไข
        </p>
      </div>

      <div class="table-days-point-wrapper">
        <table>
          <tr>
            <td v-for="(day, index) in days" :key="index">
              <p>{{ day.text }}</p>
              <input
                min="0"
                max="999"
                type="number"
                class="form-control"
                :value="localForm[day.key]"
                disabled
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnvironmentConfigForm",

  props: {
    value: {
      type: Object,
      required: true,
    },
    themes: {
      type: Array,
      default: () => [],
    },
    saveState: {
      type: String,
      default: "saved",
    },
  },

  data() {
    return {
      localForm: {
        play_sec: 0,
        point_0: 0,
        point_1: 0,
        point_2: 0,
        point_bomb: 0,
        point_vip: 0,
        theme_id: 0,
        play_day_fri: 0,
        play_day_mon: 0,
        play_day_sat: 0,
        play_day_sun: 0,
        play_day_thu: 0,
        play_day_tue: 0,
        play_day_wed: 0,
      },
      syncingFromParent: false,
    };
  },

  computed: {
    days() {
      return [
        { text: "Monday", key: "play_day_mon" },
        { text: "Tuesday", key: "play_day_tue" },
        { text: "Wednesday", key: "play_day_wed" },
        { text: "Thursday", key: "play_day_thu" },
        { text: "Friday", key: "play_day_fri" },
        { text: "Saturday", key: "play_day_sat" },
        { text: "Sunday", key: "play_day_sun" },
      ];
    },

    saveStateText() {
      switch (this.saveState) {
        case "saving":
          return "Saving...";
        case "unsaved":
          return "Unsaved";
        default:
          return "Saved";
      }
    },

    saveStateClass() {
      return {
        "is-saved": this.saveState === "saved",
        "is-saving": this.saveState === "saving",
        "is-unsaved": this.saveState === "unsaved",
      };
    },
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.syncingFromParent = true;
        this.localForm = Object.assign({}, this.localForm, value || {});
        this.$nextTick(() => {
          this.syncingFromParent = false;
        });
      },
    },
  },

  methods: {
    emitChange() {
      this.$emit("change", Object.assign({}, this.localForm));
    },

    onFieldInput() {
      if (this.syncingFromParent) return;
      this.emitChange();
    },

    onFieldBlur() {
      if (this.syncingFromParent) return;
      this.emitChange();
      this.$emit("blur");
    },
  },
};
</script>

<style lang="scss" scoped>
.save-state-row {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.save-state-label {
  color: #76838f;
  font-size: 0.875rem;
}

.save-state {
  min-width: 90px;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 600;
  background: #edf1f7;
  color: #526069;

  &.is-saved {
    color: #0b6b2b;
    background: #e7f7ed;
  }

  &.is-saving {
    color: #8a5a00;
    background: #fff4d8;
  }

  &.is-unsaved {
    color: #a94442;
    background: #fde8e7;
  }
}

.theme-row {
  gap: 1rem;
}

.no-play-row {
  gap: 1.5rem;
}

.text-help {
  margin-bottom: 0;
  color: #76838f;
  font-size: 0.875rem;
}

.config-list-table {
  table tr:first-child td {
    border-top: none;
  }
}

.table-days-point-wrapper {
  table tr td {
    min-width: 90px;
    padding-left: 1rem;
  }

  input[disabled] {
    background-color: #f3f7f9;
    cursor: not-allowed;
  }
}
</style>
